

export default { formatDatetime, formatShortDatetime, formatDate, formatTime }



function formatDatetime(s) {
    if (s === null || !s) return ''

    let d = new Date(s);
    return d
        .toLocaleString('nb-NO', { dateStyle: 'short', timeStyle: 'short' })
        .replace('.', '/');
}
function formatShortDatetime(s) {
    if (s === null || !s) return ''

    let d = new Date(s);
    return d
        .toLocaleString('nb-NO', { day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit' })
        .replace('.,', '')
        .replace('.', '/');
}

function formatDate(s) {
    if (s === null || !s) return ''

    let d = new Date(s);
    return d.toLocaleDateString('nb-NO')
}


function formatTime(s) {
    if (s === null || !s) return ''

    let d = new Date(s);
    return d.toLocaleString('nb-NO', { timeStyle: 'short' })
}

